import * as React from 'react'
function SvgArrowUp(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8 18.8a1.98 1.98 0 002.8 0l7.2-7.2V34a2 2 0 104 0V11.6l7.2 7.2A1.98 1.98 0 0032 16L21.414 5.414a2 2 0 00-2.828 0L8 16a1.98 1.98 0 000 2.8z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgArrowUp
